import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Link } from 'react-router-dom'
import { routerActions } from 'react-router-redux'
import { Loader, Dimmer, Segment, Grid } from 'semantic-ui-react'

// Styles
// import {bootstrap} from 'bootstrap/dist/css/bootstrap.css'
// import {font_awesome} from 'font-awesome/css/font-awesome.css'
// import {responsive} from './assets/css/style-responsive.css'
// import {style} from './assets/css/style.css'

import * as utils from './utils'
import {
  Dashboard,
  JobRun,
  MinionList,
} from './containers'
// import {
//   cachedConnect as connect,
//   withOnlyNotBusyUpdate
// } from './containers/helpersHOC'

import {
  Login,
  Loading,
  // Notification,
  // Aside,
  // MinionList,
  // JobRun,
  // to move to containers
  // Dashboard as DashboardComponent
  // MinionList as MinionListComponent,
} from './components'

import {
  // NavTwoColumns, NavSidebarPusher,
  NavTwoRowsTwoColumns,
  // NavTwoRowsTwoColumnsWithTransition
} from './components/NavigationDrawerLayout'

const menuItemsList = [
  {to: '/', icon: 'dashboard', name: 'Dashboard', as: Link },
  {to: '/jobs', icon: 'tasks', name: 'Jobs', as: Link},
  {to: '/minions', icon: 'cubes', name: 'Minions', as: Link},
  {to: '/job/run', icon: 'play', name: 'Run job', as: Link},
  {to: '/job/templates', icon: 'magic', name: 'Jobs templates', as: Link}
]

export default class App extends Component {
  static displayName = 'SaltApi'

  static propTypes = {
    // history: PropTypes.object,
    settings: PropTypes.object.isRequired,
    // api: PropTypes.object.isRequired,
    routerActions: PropTypes.object
  }
  static defaultProps = {
    routerActions: routerActions
  }
  static contextTypes = {
    store: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    app: PropTypes.object
  }
  static childContextTypes = {
    app: PropTypes.shape({
      actions: PropTypes.objectOf(PropTypes.func),

      // loader: PropTypes.shape({
      //   isBusy: PropTypes.bool,
      //   hasError: PropTypes.bool
      // }),
      // security: PropTypes.shape({
      //   user: PropTypes.any,
      //   isAuthenticated: PropTypes.bool,
      //   permissions: PropTypes.any,
      //   expireAt: PropTypes.any
      // }),
      // notification: PropTypes.shape({
      //   jobs: PropTypes.shape({
      //     started: PropTypes.bool,
      //     completed: PropTypes.bool,
      //     jobid: PropTypes.string
      //   }),
      //   minions: PropTypes.shape({
      //     added: PropTypes.bool,
      //     removed: PropTypes.bool,
      //     minion: PropTypes.any
      //   }),
      // }),
      // misc: PropTypes.shape({
      //   availableClients: PropTypes.array
      // }),
      // redirector: PropTypes.objectOf(PropTypes.func),
    }),
    router: PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    window._app = this
    console.log('App', props, context)

    this.api = utils.getSaltApi(this.props.settings)

    this.redirector = require('./App.redirector').createRedirectManager({
      dispatch: this.context.store.dispatch,
      actions: this.props.routerActions,
      history: this.context.history || utils.getHistory() || window.history})

    // this.api._prevent_any_status_changes = true
    this.api.isAuthenticated()
    // this.api._prevent_any_status_changes = false
    this.state = this.computeState(this.api)
    // this.setupRouteChangedHandler()

    this.setupRouteChangedHandler = require(
      './App.utils').setupRouteChangedHandler.bind(this)
  }

  getChildContext() {
    //let { loader, security, notification, misc } = this.state
    // let { loader, security, notification, misc } = this.computeState(this.api)
    // console.log('App getChildContext', this.context)
    return {
      router: this.context.router,
      app: {
        ...this.context.app,

        actions: _.mapValues(require('./App.actions'), f => {
          return f.bind(this)
        })
      }
    }
  }

  computeState = (newProps) => {
    let newState = {}
    newState.loader = {
      isBusy: (newProps.async||this.api.async).busy,
      hasError:_.isObject((newProps.async||this.api.async).error),
      errorObject: (newProps.async||this.api.async).error
    }
    newState.security = {
      user: (newProps.auth||this.api.auth).user,
      isAuthenticated: _.size(this.api.auth) > 0,
      permissions: (newProps.auth||this.api.auth).perms,
      expireAt: (newProps.auth||this.api.auth).expire
    }

    // newState.notification = {
    //   jobs: { started: false, completed: false, jobid: null },
    //   minions: {added: false, removed: false, minion: null }
    // }
    newState.misc = {
      minions: newProps.minions || this.api.minions,
      availableClients: newProps.availableClients || this.api.availableClients,
      filteredJobs: newProps.jobs || this.api.jobs,
      allJobs: newProps.allJobs || this.api.allJobs,
      pendingJobsIds: newProps.pendingJobsIds || this.api.pendingJobsIds,
      completedJobsIds: newProps.completedJobsIds || this.api.completedJobsIds
    }
    // console.log('App computeState', newProps, newContext, this.state, newState)
    return newState
  }


  refreshAll = () => {
    console.log('refreshAll', this.props, this.api)
    let promises = []
    if (_.size(this.api.availableClients) === 0) {
      promises.push(() => this.api.getWelcome())
    }
    if (_.size(this.api.keys) === 0) {
      promises.push(() => this.api.getKeys('*'))
      promises.push(() => this.api.getStatus())
    }
    if (_.size(this.api.grains) === 0) promises.push(() => this.api.getGrains())
    if (_.size(this.api.jobs) === 0) promises.push(() => this.api.getJobs())
    if (_.isUndefined(this.api.__allDocs) === false)
      promises.push(() => this.api.initDocs())
    if (_.size(promises) > 0) {
      this.api.setBusy()
      this.api._prevent_async_status_changes = true
      return Promise
        .all(_.map(promises, pFn => pFn()))
        .then(resultedPromises => {
          console.log('refreshAll resusts: ', resultedPromises)
          this.api._prevent_async_status_changes = false
          this.api.setDone()
        })
        .catch(err => {
          this.api._prevent_async_status_changes = false
          this.api.setError(err)
        })
    }
  }

  componentWillUnmount() {
    this.usubscribeRouteChangedHandler()
  }

  componentDidMount() {
    this.setupRouteChangedHandler()
    if (this.state.security.isAuthenticated || this.api.isAuthenticated()) {
      this.refreshAll()
    }
  }

  // componentWillReceiveProps(props) {
  //   // console.log('App componentWillReceiveProps', props, context, args)
  //   // console.log(' ... props was', this.props)
  //   // console.log(' ... staate was', this.state)
  //   this.setState(this.computeState(props))
  // }

  onLogin = (username, password) => {
    this.setState({loader: {isBusy: true}})
    this.api.login(username, password).then(this.refreshAll).then(
      () => {
        this.setState(this.computeState(this.api))
      })
  }
  onLogout = () => {
    this.setState({loader: {isBusy: true}})
    this.api.logout().then(
      () => {
        this.setState(this.computeState(this.api))
      })
  }

  render() {
    console.log('App render')
    if (!(this.state.security.isAuthenticated || this.api.isAuthenticated()))
      //if (!(this.state.security.isAuthenticated))
      return this.renderLoginPage()

    return this.renderMainPage()
  }

  renderLoginPage = () => {
    return (
      <div>
        <Loading
          isLoading={this.state.loader.isBusy}
          hasError={this.state.loader.hasError}
          errorObject={this.state.loader.errorObject} />
        <Login onLoginSubmit={this.onLogin.bind(this)} />
      </div>
    )
  }

  renderMainPage = () => {
    // let sideContent = (
    //   <Aside menuLinks={[
    //     {to: '/', icon: 'dashboard', title: 'Dashboard'},
    //     {to: '/jobs', icon: 'tasks', title: 'Jobs'},
    //     {to: '/minions', icon: 'cubes', title: 'Minions'},
    //     {to: '/job/run', icon: 'play', title: 'Run job'},
    //     {to: '/job/templates', icon: 'magic', title: 'Jobs templates'}
    //   ]} user={this.state.security.user}/>
    // )

    let mainContent = (
      <Segment as={'section'} id='main-content' basic>

        <Grid columns='equal' style={{padding: '0px'}}>

          <Grid.Column style={{paddingLeft: '0px'}}>
            <Route exact path='/' component={Dashboard} />

            <Route exact path='/jobs' component={() =>
              <div>JOBS</div>} />

            <Route exact path='/minions' component={MinionList} />

            <Route exact path='/job/run' component={JobRun} />

          </Grid.Column>

        </Grid>

        {/*
            <Segment textAlign={'center'}>
            {_.times(3, i => <br key={`0${i}_1st`} />)}
            <p key={`p`}>MAIN CONTENT VIEW --- {'aaaa'}</p>
            {_.times(3, i => <br key={`1${i}_2nd`}/>)}
            </Segment>
            <Segment textAlign={'center'}>
            {_.times(3, i => <br key={`0${i}_1st`} />)}
            <p key={`p`}>MAIN CONTENT VIEW --- {'aaaa'}</p>
            {_.times(3, i => <br key={`1${i}_2nd`}/>)}
            </Segment>
            <Segment textAlign={'center'}>
            {_.times(3, i => <br key={`0${i}_1st`} />)}
            <p key={`p`}>MAIN CONTENT VIEW --- {'aaaa'}</p>
            {_.times(3, i => <br key={`1${i}_2nd`}/>)}
            </Segment>
          */}

      </Segment>

    )

    return (
      <div style={{height: '80vh'}}>
        <Loading
          isLoading={this.state.loader.isBusy}
          hasError={this.state.loader.hasError}
          errorObject={this.state.loader.errorObject}
          whenIsLoading={() => <Dimmer active page><Loader/></Dimmer>}/>

        <NavTwoRowsTwoColumns

          onLogout={this.onLogout}
          menuItems={menuItemsList}>
          {mainContent}

        </NavTwoRowsTwoColumns>

      </div>

    )
  }

}
// App.displayName = 'SaltApi'
// App.propTypes = {
//   // history: PropTypes.object,
//   settings: PropTypes.object.isRequired,
//   // api: PropTypes.object.isRequired,
//   routerActions: PropTypes.object
// }
// App.defaultProps = {
//   routerActions: routerActions
// }
// App.contextTypes = {
//   store: PropTypes.object.isRequired,
//   router: PropTypes.object.isRequired,
//   app: PropTypes.object
// }
// App.childContextTypes = {
//   app: PropTypes.shape({
//     actions: PropTypes.objectOf(PropTypes.func),

//     loader: PropTypes.shape({
//       isBusy: PropTypes.bool,
//       hasError: PropTypes.bool
//     }),
//     security: PropTypes.shape({
//       user: PropTypes.any,
//       isAuthenticated: PropTypes.bool,
//       permissions: PropTypes.any,
//       expireAt: PropTypes.any
//     }),
//     notification: PropTypes.shape({
//       jobs: PropTypes.shape({
//         started: PropTypes.bool,
//         completed: PropTypes.bool,
//         jobid: PropTypes.string
//       }),
//       minions: PropTypes.shape({
//         added: PropTypes.bool,
//         removed: PropTypes.bool,
//         minion: PropTypes.any
//       }),
//     }),
//     misc: PropTypes.shape({
//       availableClients: PropTypes.array
//     }),
//     redirector: PropTypes.objectOf(PropTypes.func),
//   }),
//   router: PropTypes.object
// }



// WEBPACK FOOTER //
// ./src/App.js